import { Controller } from '@hotwired/stimulus'
import { loadPhoneInput, validateInput, resetValidations } from '../../modules/phone_input'

/**
 * Simple intl-tel-input controller for phone number input with validation.
 *
 * Usage:
 *   <form data-controller="kycs--intl-tel-input">
 *     <input type="tel" data-kycs--intl-tel-input-target="input" data-country="sg" />
 *     <span data-kycs--intl-tel-input-target="error" class="text-danger d-none"></span>
 *     <span data-kycs--intl-tel-input-target="valid" class="text-success d-none"></span>
 *   </form>
 *
 * Note: intl-tel-input creates a hidden input named "phone_intl_tel_output" with E.164 formatted number.
 */
export default class extends Controller {
  static targets = ['input', 'error', 'valid']

  connect() {
    this._loadPhoneInput()
  }

  _loadPhoneInput() {
    if (this.iti) return

    const country = this.inputTarget.dataset.country || 'sg'

    this.iti = loadPhoneInput(
      this.inputTarget,
      country,
      this.errorTarget,
      this.validTarget
    )
  }

  validate() {
    return validateInput(
      this.iti,
      this.inputTarget,
      this.errorTarget,
      this.validTarget
    )
  }

  reset() {
    resetValidations(
      this.inputTarget,
      this.errorTarget,
      this.validTarget
    )
  }
}
